import * as React from 'react';
export default function getSpanPickerTimeFromStr(str) {
    // Just to add 4px padding before year 🤯
    var strToArr = str.split(' ');
    var lastSpan = React.createElement("span", { style: { paddingLeft: '4px' } }, strToArr.pop());
    var mappedWeek = strToArr.map(function (el, i) {
        if (i !== strToArr.length - 1) {
            return React.createElement("span", { key: i }, el + ' ');
        }
        return React.createElement("span", { key: i }, el);
    });
    return (React.createElement(React.Fragment, null,
        mappedWeek,
        " ",
        lastSpan));
}
//# sourceMappingURL=getSpanPickerTimeFromStr.js.map